import Store from '@/store/'
import { Model } from '@vuex-orm/core'
import Item from './ItemModel'
import FieldTypes from '@/constants/FieldTypes'
import ValidationRules from '@/constants/ValidationRules'
import addClassesToModelHeaders from '@/utils/addClassesToModelHeaders'

export default class SectionModel extends Model {
  static entity = 'sections'

  static nameSingular = 'Section'
  static namePlural = 'Sections'

  static fields() {
    return {
      id: this.uid(),
      name: this.string(''),
      description: this.string('', (desc) => (desc !== 'null' ? desc : '')),
      order: this.number(),
      items: this.hasMany(Item, 'section_id'),
      shop_id: this.attr(null),
    }
  }

  static field_headers() {
    let headers = [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'name',
        type: FieldTypes.TEXTAREA,
        rules: [ValidationRules.requiredString],
        sticky: true,
      },
      {
        text: 'Description',
        value: 'description',
        sortable: true,
        type: FieldTypes.TEXTAREA,
      },
      {
        text: 'No. Items',
        value: 'num_items',
        type: FieldTypes.TEXT,
        sortable: false,
        hideOnDetail: true,
      },
      {
        text: 'Order',
        value: 'order',
        type: FieldTypes.NUMBER,
        align: 'center',
        rules: [ValidationRules.unsignedNumberRule],
      },
    ]
    return addClassesToModelHeaders(headers)
  }

  static index_table_config() {
    return {
      dense: false,
    }
  }

  static index_query_with() {
    return 'items'
  }

  static fetchMenuByShopSlug(slug) {
    return this.api().get(`/shops/slug/${slug}/menu`)
  }

  static rearrangeMenu(updatedMenuArrangement) {
    let shopId = Store.getters['shop/getShopId']
    return this.api().post(`/shops/${shopId}/menu`, updatedMenuArrangement)
  }

  /**
   * Get price adjusted in USD (cents x 100)
   */
  get price_usd() {
    return this.price / 100
  }

  /**
   * Get priced formatted like a -$D,DDD.CC
   */
  get price_formatted() {
    const prefix = this.price_usd < 0 ? '-$' : '$'
    return `${prefix}${Math.abs(this.price_usd).toFixed(2)}`
  }

  get num_items() {
    return this.items.length
  }
}
